module.exports = __webpack_public_path__ + "img/26.f10baf30.png";